module.exports = __webpack_public_path__ + "static/media/case.aafc9302.png";